const MoroccoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111947)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M31.8199 16.4143H22.7907L20.0005 7.82715L17.2104 16.4143H8.18115L15.4859 21.7215L12.6957 30.3089L20.0005 25.0017L27.3054 30.309L24.5151 21.7216L31.8199 16.4143ZM17.5304 21.0572L18.4739 18.1534H21.5271L22.4707 21.0572V21.0573L20.0005 22.8519L17.5304 21.0573L17.5304 21.0572ZM20.9621 16.4143H19.039L20.0005 13.455L20.9621 16.4143ZM23.95 19.9825L23.3557 18.1535H26.4673L23.95 19.9825ZM16.6453 18.1535L16.051 19.9825L13.5336 18.1535H16.6453ZM16.0037 25.7558L16.9653 22.7965L18.5212 23.9268L16.0037 25.7558ZM21.4799 23.9269L23.0358 22.7966L23.9973 25.7559L21.4799 23.9269Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111947">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MoroccoSvg;
